import { useCallback } from 'react';

import { useSelector } from 'react-redux';

import {
  getChangeEvent,
  getPlaneChangeEvent,
} from 'components/modules/Insurance/Insurance.helpers';
import { FIELDS } from 'store/insuranceAnketa/constants';

import { useDisabledFields } from '../../hooks/useDisabledFields';
import { useStoreHelper } from '../../hooks/useStoreHelper';

export const usePersonalDataPresenter = ({ isOwnerForm }) => {
  const { errorsSelector, onChangeValue, valuesSelector } = useStoreHelper({ isOwnerForm });
  const { disabled: pageRestrict } = useDisabledFields();

  const errors = useSelector(errorsSelector);
  const values = useSelector(valuesSelector);

  const onChange = useCallback(
    (event) => {
      const { key, value } = getChangeEvent(event);

      onChangeValue({ key, value });
    },
    [onChangeValue]
  );
  const onChangeGender = useCallback(
    (event) => {
      const key = FIELDS.GENDER;
      const value = getPlaneChangeEvent(event);

      onChangeValue({ key, value });
    },
    [onChangeValue]
  );

  return {
    disabled: pageRestrict,
    errors,
    onChange,
    onChangeGender,
    values,
  };
};
